import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, AbstractControl, FormControl } from '@angular/forms';
import { TEXT_CONSTANTS } from '../../constants/text-constants';

@Component({
  selector: 'description-addon',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './description-addon.component.html',
})
export class DescriptionAddonComponent {
  TEXT = TEXT_CONSTANTS;

  @Input() control!: AbstractControl;
  @Input() placeholder = '';
  @Output() remove = new EventEmitter<void>();
  @Output() change = new EventEmitter<void>();

  get fc(): FormControl { return this.control as FormControl; }
}
